export default {
  lstTab: {
    System: 'System',
    Personal: 'Personal',
  },
  Notification: {
    RevenueBreakout: 'Revenue Breakout',
    ProfitBreakout: 'Profit Breakout',
    Watchout: 'Watchout',
    UpgradeScoring: 'Upgrade Scoring',
    News: 'News',
    TASignals: 'TA Signals',
    PromissingDividend: 'Promissing Dividend',
    TAStrategy: 'TA Stategy',
    PriceAndVolume: 'Price And Volume',
    JapaneseCandlestick: 'Japanese Candlestick',
  },
  errorFormTitle: 'Unable to save screen',
  errorFormMessage: 'To save a screen, you need choose a ticker',
  noNotification: 'No notification',
  fundamental: 'Fundamental',
  events: 'Event',
  technical: 'Technical',
  setting: 'Setting',
  tableTitle: {
    name: 'NAME',
    active: 'ACTIVE',
  },
  alertCode: {
    All: 'All',
    BreakOut: 'Break-out Revenue/Profit',
    FallDown: 'Fall down Revenue/Profit',
    FinancialAssessment: 'Financial Assessment',
    Ranking: 'Ranking',
    Technical: 'Technical',
    CompanyEvents: 'Company Events',
    PriceVolume: 'Price - Volume',
    PersonalAlert: 'Personal Alert',
  },
};
